import { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import { Link, NavLink } from "react-router-dom";
import { Avatar, Tooltip } from "@mui/material";
import useAuth from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useSendLogoutMutation } from "../features/auth/authApiSlice";
import { selectCurrentToken } from "../features/auth/authSlice";
import SearchBar from "./SearchBar";

// const pages = ["How to Rent", "NFT", "Property", "Whitepaper", "Contact Us"];
// const pages = ["Property"];
// const pages = ["1"];

// Added individual link to discard complexity [Now, {My Items, my-item} will work]
// const settings = ["My Items", "Users", "Publish Property", "My Properties", "Logout"];

function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [searchValue, setSearchValue] = useState(""); // Add search state

  const { username, picture, isManager, isAdmin, isOwner } = useAuth();
  const authUser = useSelector(selectCurrentToken);

  /* Start */
  const navigate = useNavigate();

  const [sendLogout, { isLoading, isSuccess, isError, error }] =
    useSendLogoutMutation();

  const handleLogout = async () => {
    try {
      await sendLogout().unwrap(); // Perform the logout API call

      // Navigate to login page after successful logout
      navigate("/login");
    } catch (error) {
      console.error("Failed to logout:", error);
    }
  };

  useEffect(() => {
    if (isSuccess) navigate("/");
  }, [isSuccess, navigate]);

  // if (isLoading) return <p>Logging Out...</p>;

  if (isError) return <p>Error: {error.data?.message}</p>;
  /* End */

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  return (
    <AppBar
      // position="static"
      position="sticky"
      sx={{
        bgcolor: "white",
        color: "black",
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* Big Screen */}
          {/* 1. Header */}
          {/* <AdbIcon sx={{ display: { xs: "none", md: "flex" }, mr: 1 }} /> */}
          <NavLink to="/" className="navlink-title">
            <Typography
              variant="h6"
              noWrap
              // component="a"
              // href="#app-bar-with-responsive-menu"
              sx={{
                mx: 2,
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
                // borderBottom: "3px solid transparent",
              }}
            >
              PGROOTS
              {/* Header */}
            </Typography>
          </NavLink>

          {/* 2. Pages */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
            }}
          >
            {/* {pages.map((page) => (
              <NavLink
                key={page}
                to={page.replace(/\s/gi, "-").toLowerCase()}
                target="_self"
                className={({ isActive }) => {
                  return isActive ? "active-nav" : "";
                }}
              >
                <Button
                  className="nav-button"
                  key={page}
                  onClick={handleCloseNavMenu}
                  sx={{
                    my: 2,
                    color: "inherit",
                    display: "block",
                    textTransform: "none",
                    border: "3px solid transparent",
                  }}
                >
                  {page}
                </Button>
              </NavLink>
            ))} */}
          </Box>

          {/* --- Desktop Search Bar (CENTER) --- */}
          {/* Takes up most of the central space on desktop */}
          <Box
            // sx={{ display: { xs: "none", md: "flex" }, flexGrow: 1 }}
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              display: { xs: "none", md: "flex" }, // show on desktop only — change as needed
              // zIndex: 20,
              // pointerEvents: "auto", // ensure clicks work
            }}
          >
            <SearchBar
              searchValue={searchValue} // Pass the shared state
              onSearchChange={handleSearchChange} // Pass the change handler
            />
            {/* <SearchBar
              searchValue={searchValue}
              onSearchChange={handleSearchChange}
              onSearch={(searchParams) => {
                // Handle the search with all parameters
                console.log("Search parameters:", searchParams);
                // Navigate to search results page or update state
              }}
            /> */}
          </Box>

          {/* Small Screen */}
          {/* 1. Pages */}
          {/* <Box
            sx={{
              flexGrow: 1,
              display: { xs: "flex", md: "none" },
            }}
          >
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: "block", md: "none" } }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={handleCloseNavMenu}>
                  <Typography sx={{ textAlign: "center" }}>
                    <NavLink
                      to={page.replace(/\s/gi, "-").toLowerCase()}
                      target="_self"
                      className="navlink-title"
                    >
                      {page}
                    </NavLink>
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box> */}
          {/* 2. Header */}
          {/* <AdbIcon sx={{ display: { xs: "flex", md: "none" }, mr: 1 }} /> */}
          <Typography
            variant="h5"
            noWrap
            sx={{
              mx: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              // letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            <NavLink to="/" className="navlink-title">
              <Box fontFamily="monospace">
                PGROOTS
                {/* Header */}
              </Box>
            </NavLink>
          </Typography>

          {/* Small & Big Screen */}
          {/* 3. Sign in & User Details */}
          {/* <Box sx={{ flexGrow: 0 }}> */}
          <Box sx={{ mx: 2 }}>
            {!authUser ? (
              <Button variant="outlined" color="inherit">
                <Link
                  style={{ color: "inherit", textDecoration: "none" }}
                  to="/login"
                >
                  Sign In
                </Link>
              </Button>
            ) : (
              <Box
                display="flex" // Enables flexbox layout
                flexDirection="row" // Arrange buttons horizontally (use "column" for vertical)
                gap={2} // Adds a consistent gap between buttons (2 * theme.spacing unit)
                justifyContent="center" // Centers the buttons
                alignItems="center" // Aligns items along the cross-axis
              >
                <Tooltip title={username}>
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar alt={username} src={picture} />
                  </IconButton>
                </Tooltip>
                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  {/* To display user full name & email along with user Menu */}
                  {/* <Box
                  paddingX={2}
                  paddingBottom={1}
                  borderBottom={1}
                  fontSize={5}
                >
                  <Typography sx={{ textAlign: "left", fontSize: "14px" }}>
                    {auth?.name}
                  </Typography>
                  <Typography sx={{ textAlign: "left", fontSize: "12px" }}>
                    {auth?.email}
                  </Typography>
                </Box> */}
                  {/* <MenuItem key="my-assets" onClick={handleCloseUserMenu}>
                    <Link to="my-assets" className="navlink-title">
                      My Assets
                    </Link>
                  </MenuItem> */}
                  <MenuItem key="my-properties" onClick={handleCloseUserMenu}>
                    <Link to="my-properties" className="navlink-title">
                      My Properties
                    </Link>
                  </MenuItem>
                  <MenuItem key="add-property" onClick={handleCloseUserMenu}>
                    <Link to="my-properties/new" className="navlink-title">
                      Add Property
                    </Link>
                  </MenuItem>
                  {/* <MenuItem key="add-units" onClick={handleCloseUserMenu}>
                    <Link to="my-units/new" className="navlink-title">
                      Add Units
                    </Link>
                  </MenuItem> */}
                  {/* {(isOwner || isAdmin || isManager) && (
                    <MenuItem key="users" onClick={handleCloseUserMenu}>
                      <Link to="users" className="navlink-title">
                        Users
                      </Link>
                    </MenuItem>
                  )} */}
                  <MenuItem key="logout" onClick={handleCloseUserMenu}>
                    <Typography onClick={handleLogout}>Logout</Typography>
                  </MenuItem>
                  {/* {settings.map((setting) => (
                    <MenuItem key={setting} onClick={handleCloseUserMenu}>
                      <Typography
                        sx={{ textAlign: "center" }}
                        // onClick={setting === "Logout" ? logoutUser : undefined}
                        onClick={setting === "Logout" ? sendLogout : undefined}
                      >
                        {setting === "Logout" ? (
                          setting
                        ) : (
                          <Link
                            to={setting.replace(/\s/gi, "-").toLowerCase()}
                            className="navlink-title"
                          >
                            {setting}
                          </Link>
                        )}
                      </Typography>
                    </MenuItem>
                  ))} */}
                </Menu>
              </Box>
            )}
          </Box>
        </Toolbar>

        {/* --- Mobile Search Bar (SEPARATE BAR/ROW) --- */}
        {/* This Box is outside the first Toolbar to force a new row/section,
           only displayed on small screens (xs) and takes full width. */}
        <Box
          sx={{
            display: { xs: "block", md: "none" },
            p: 1,
            // To make it look like part of the AppBar, we include a minimal toolbar-like style
            bgcolor: "inherit",
            width: "100%",
          }}
        >
          <SearchBar
            searchValue={searchValue} // Pass the shared state
            onSearchChange={handleSearchChange} // Pass the change handler
          />
          {/* <SearchBar
            searchValue={searchValue}
            onSearchChange={handleSearchChange}
            onSearch={(searchParams) => {
              // Handle the search with all parameters
              console.log("Search parameters:", searchParams);
              // Navigate to search results page or update state
            }}
          /> */}
        </Box>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
